export default "__VITE_ASSET__CDKx$9sO__"